import { Paths } from '../../../../../apps/backoffice/src/lib/constants/path'

export const constructClientPath = (path: string, id?: string | number): string => {
  if (!id) return 'client-page-not-found'

  return Paths.CLIENT_SPACE_LAYOUT.replace(':id', id.toString()).replace('*', '') + path
}

export const constructAffectedStaffPath = (path: string, id?: string | number): string => {
  if (!id) return 'staff-personal-space-page-not-found'
  return (
    Paths.STAFF_PERSONAL_SPACE_JOURNEY_DETAILS.replace(':id', id.toString()).replace('*', '') +
    path
  )
}
